import React, {useState} from 'react';
// import {useDispatch} from 'react-redux';
// import { setCompliancePercentage } from "../../../../store/actions/complianceTableActions"
import 'antd/dist/antd.css';
import './CustomSlider.css';
import { Slider, Row, Col } from 'antd';


const SliderLable = (props) => {
    return <div className="sliderLable">{props.value} %</div>
}

export function CustomSlider(props){
    const {range, setCompRange} = props;
    const [selectedRange, setSelectedRange] = useState([0, 100]);
    // const dispatch = useDispatch();

    return (<Row>
        <Col xs={3}>
            <SliderLable value={selectedRange[0]}/>
        </Col>
        <Col xs={18}>
            <Slider 
                value = {selectedRange}
                trackStyle={{ color : "#3b6cb4"}}
                tooltipVisible={false}
                id = "slider-component"
                className="customSlider"
                range = {range}      
                onChange={
                    (value)=>{
                        if(value[0]%1 === 0){
                            setSelectedRange([...value]);
                        }
                    }
                }
                onAfterChange={
                    (value)=>{
                        if(value[0]%1 === 0){
                            setCompRange(value);
                        }
                    }
                }
            />

        </Col>
        <Col xs={3}>
            <SliderLable value={selectedRange[1]}/>
        </Col>
    </Row>);
}

